import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const DefaultImage = styled.img<{
  isLoaded: boolean;
}>`
  width: auto;
  position: relative;
  max-width: 100%;
  max-height: 1200px;
  padding: ${({ isLoaded }) => (isLoaded ? '0' : '12px')};
  padding-top: ${({ isLoaded }) => (isLoaded ? '0' : '52px')};

  &:before,
  &:after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    top: 0;
    left: 0;
    background: #fff;
    color: #fff;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    font-size: ${theme.font.size.copy};
    padding: 12px;
  }

  &:after {
    content: ${({ isLoaded }) => (isLoaded ? '" "' : 'attr(alt)')};
    display: flex;
    align-items: flex-end;
    text-align: center;
    background: ${({ isLoaded }) =>
      isLoaded ? '#fff' : 'linear-gradient(#fff, rgba(0,0,0,.81))'};
  }
`;
